import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import './App.css';
import Routes from './Routes';
import { Auth } from 'aws-amplify';
import MetaTags from 'react-meta-tags';
import CookieBanner from 'react-cookie-banner';
import ReactGA from 'react-ga';

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isAuthenticated: false,
      isAuthenticating: true,
      accountType: 'none'
    };

    ReactGA.initialize('UA-116843398-2');
    ReactGA.pageview(window.location.pathname + window.location.search);
  }

  async componentDidMount() {
    try {
      if (await Auth.currentSession()) {
        this.userHasAuthenticated(true);
      }
    } catch (e) {
      if (e !== 'No current user') {
        alert(e);
      }
    }

    this.setState({ isAuthenticating: false });
  }

  userHasAuthenticated = authenticated => {
    if (authenticated) {
      this.setAccountType();
    }
    this.setState({ isAuthenticated: authenticated });
  };

  setAccountType = async event => {
    let user = await Auth.currentAuthenticatedUser();
    const accttype = user.attributes['custom:type'];
    if (accttype !== undefined) {
      this.setState({ accountType: accttype });
    } else {
      this.setState({ accountType: 'free' });
    }
  };

  appLogout = async event => {
    await Auth.signOut();

    this.userHasAuthenticated(false);

    this.props.history.push('/login');
  };

  render() {
    const childProps = {
      isAuthenticated: this.state.isAuthenticated,
      userHasAuthenticated: this.userHasAuthenticated,
      appLogout: this.appLogout,
      accountType: this.state.accountType,
      setAccountType: this.setAccountType
    };

    /* const styles = {
      banner: {
        fontFamily: "ArialRoundedMT",
        height: "100px",
        background:
          "rgba(52, 64, 81, 0.88) url(/cookie.png) 20px 50% no-repeat",
        backgroundSize: "30px 30px",
        backgroundColor: "",
        fontSize: "15px",
        fontWeight: 600,
        position: "fixed",
        bottom: "20px",
        zIndex: 9,
        left: "10%",
        width: "80%"
      },
      button: {
        border: "1px solid white",
        borderRadius: 4,
        width: 66,
        height: 32,
        lineHeight: "32px",
        background: "transparent",
        color: "white",
        fontSize: "14px",
        fontWeight: 600,
        opacity: 1,
        right: 20,
        marginTop: -18
      },
      message: {
        display: "block",
        padding: "9px 67px",
        lineHeight: 1.3,
        textAlign: "left",
        marginRight: 244,
        color: "white"
      },
      link: {
        fontWeight: "bold"
      }
    }; */

    return (
      !this.state.isAuthenticating && (
        <div className="App container">
          <MetaTags>
            <meta name="twitter:card" content="summary" />
            <meta name="twitter:site" content="@vis_analytics" />
            <meta property="og:url" content="" />
            <meta property="og:site_name" content="Digimasters VA Estimator" />
            <meta property="og:type" content="website" />
            <meta itemProp="name" content="Digimasters VA Estimator" />
            <meta name="twitter:title" content="Digimasters VA Estimator" />
            <meta property="og:title" content="Digimasters VA Estimator" />
            <meta
              itemProp="description"
              content="A project estimation tool for visual analytics applications."
            />
            <meta
              name="description"
              content="A project estimation tool for visual analytics applications."
            />
            <meta
              property="og:description"
              content="A project estimation tool for visual analytics applications."
            />
            <meta
              name="twitter:description"
              content="A project estimation tool for visual analytics applications."
            />
            <meta
              property="og:image"
              content="http://digimasters.co.uk/images/logo_large.jpg"
            />
            <meta
              name="image"
              content="http://digimasters.co.uk/images/logo_large.jpg"
            />
            <meta
              itemProp="image"
              content="http://digimasters.co.uk/images/logo_large.jpg"
            />
            <meta
              name="twitter:image"
              content="http://digimasters.co.uk/images/logo_large.jpg"
            />
          </MetaTags>
          <CookieBanner
            /* styles={styles} */
            message="Our website uses cookies. By continuing we assume your permission to deploy cookies. "
            dismissOnScroll={false}
            disableStyle={true}
            link={
              <a
                href="http://digimasters.co.uk/privacy-cookies-policy.php"
                target="_blank"
                rel="noopener noreferrer">
                For more information please read our privacy policy.
              </a>
            }
          />
          <Routes childProps={childProps} />
        </div>
      )
    );
  }
}

export default withRouter(App);



// WEBPACK FOOTER //
// ./src/App.js